export const ENABLE_CANARY_VERSION =
  "shared/CanaryVersions/ENABLE_CANARY_VERSION";

const PNP_BASE_OFFERS = "pnp-base-offers";
const MX_WB = "mx-wb"; // mexico weight breaks
const FI_MID_RANGE = "fi-mid-range"; // mexico weight breaks

const PNP_UPGRADED_OFFERS = "pnp-upgraded-offers";
const EXPRESS3 = "express3";

export const TYPES_OF_CANARY_VERSIONS = {
  canary1: "canary1",
  canary2: "canary2",
  canary3: "canary3",
  wccoffers: "wccoffers",
  strikethrough: "strikethrough",
  [MX_WB]: MX_WB,
  [PNP_BASE_OFFERS]: PNP_BASE_OFFERS,
  [PNP_UPGRADED_OFFERS]: PNP_UPGRADED_OFFERS,
  [EXPRESS3]: EXPRESS3,
  [FI_MID_RANGE]: FI_MID_RANGE,
};
